import { render, staticRenderFns } from "./PscInspectionByFlag.vue?vue&type=template&id=47b37edd&scoped=true&"
import script from "./PscInspectionByFlag.vue?vue&type=script&lang=js&"
export * from "./PscInspectionByFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b37edd",
  null
  
)

export default component.exports